module.exports = __webpack_public_path__ + "static/img/link3.3295397.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/link3.png
// module id = Luu2
// module chunks = 0